import type { Descarga } from './api.js';

/** Reparte una lista en descargas sueltas y temporadas (D-27), conservando el orden: cada
 *  grupo va donde estaba su primer episodio. Un episodio solo no forma grupo. */
export function agruparPorTemporadas(items: Descarga[]): ({ tipo: 'suelta'; d: Descarga } | { tipo: 'temporada'; descargas: Descarga[] })[] {
  const grupos = new Map<string, Descarga[]>();
  for (const d of items) {
    if (d.movieKind !== 'show' || !d.movieId) continue;
    const clave = `${d.movieId}:${d.season ?? 'sin'}`;
    grupos.set(clave, [...(grupos.get(clave) ?? []), d]);
  }
  const salida: ReturnType<typeof agruparPorTemporadas> = [];
  const pintados = new Set<string>();
  for (const d of items) {
    const clave = d.movieKind === 'show' && d.movieId ? `${d.movieId}:${d.season ?? 'sin'}` : null;
    const grupo = clave ? grupos.get(clave) : undefined;
    if (!grupo || grupo.length < 2) {
      salida.push({ tipo: 'suelta', d });
      continue;
    }
    if (pintados.has(clave!)) continue;
    pintados.add(clave!);
    salida.push({ tipo: 'temporada', descargas: grupo });
  }
  return salida;
}
